import React from 'react';
import { motion } from 'framer-motion';

const Blueprint = () => {
  return (
    <section className="py-24 bg-stone-50 border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }}
          >
            <span className="text-emerald-600 font-bold uppercase tracking-widest text-sm mb-2 block">
              System-Architektur
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-stone-900">
              Hydroponik-Version des Alchemist 1.0
            </h2>
            <p className="text-stone-600 text-lg">
              Detailansicht der Standard-Ausstattungsvariante. Gezeigt: Aeroponik- und Ebb-Flow-Decks innerhalb der anwendungsneutralen Reinraum-Plattform.
            </p>
          </motion.div>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true, margin: "-50px" }} 
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl overflow-hidden shadow-2xl border border-stone-200/60 bg-white"
        >
          <img 
            src="https://media-manager-c.questera.ai/greta-media/6a4e1632643f5ecd6b4b884d4518abad28ee28269a896d1a9bb8c081180db7d41fc79629d873bafacdf5fb95106d974d/images/aW1hZ2UvcG5n/65e46d4142e5c2313158b3c1891bd101.png" 
            alt="Technische Zeichnung: Alchemist 1.0 - Hydroponik-Version" 
            className="w-full h-auto object-contain block hover:scale-[1.02] transition-transform duration-700" 
          />
          <div className="p-6 bg-stone-900 text-stone-400 text-xs italic text-center">
            Gezeigt: Hydroponik-Version (Standard-Ausstattungsvariante). Container, Klimahülle und CoreVoice-Steuerung sind für alle Ausstattungsvarianten identisch — nur die Kultivierungsebene wird je nach Anwendung angepasst.
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Blueprint;